import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, ValidationErrors } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule, MatError } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule, MatStepper } from '@angular/material/stepper';
import { SharedModuleV4 } from '../../../../../shared/sharedv4.module';
import { AsFormControlPipe } from '../../../../../transforms/form-control-pipe';
import { FormButtonGroupSimpleComponent } from '../../../../shared/form-button-group-simple/form-button-group-simple.component';
import { DateRangeType, FormFieldDateComponent } from '../../../../shared/form-field-date/form-field-date.component';
import { FormFieldNumericComponent } from '../../../../shared/form-field-numeric/form-field-numeric.component';
import { FormFieldSelectComponent, SelectListType } from '../../../../shared/form-field-select/form-field-select.component';
import { FormFieldComponent } from '../../../../shared/form-field/form-field.component';
import { AddressComponent } from '../../address/address.component';
import { BaseStepComponent } from '../../base-step/base-step.component';
import { ApplicationFormControlNames } from '../../../../../types/v4/applicationFromControlNames';
import { UserAction } from '../../../../../api/v4/models/CommonUtilities/user-action';
import { GenderEnum } from '../../../../../api/v4/models/Models/v4/Application/gender-enum';
import { MaritalStatusEnum } from '../../../../../api/v4/models/Models/v4/Application/PersonalDetails/marital-status-enum';
import { LookupService } from '../../../../../services/v4/lookup.service';
import { ListItem } from '../../../../../types/listItem';
import { Country } from '../../../../../api/v4/models/CommonUtilities/country';
import { Step2PersonalIdentificationForm, PersonalIndividualForm } from '../../../../../types/v4/personal-individual-steps';
import { PersonalAppService } from '../../../../../services/v4/personal-app.service';
import { Constants } from '../../../../../dataobject/constants';
import { startWith, pairwise } from 'rxjs';
import { VisaCategory } from '../../../../../api/v4/models/CommonUtilities/visa-category';
import { IdentificationTypeEnum } from '../../../../../api/v4/models/Models/v4/Application/Identification/identification-type-enum';
import { ResidencyStatusEnum } from '../../../../../api/v4/models/Models/v4/Application/Identification/residency-status-enum';
import { VisaTypeEnum } from '../../../../../api/v4/models/Models/v4/Application/Identification/visa-type-enum';

@Component({
  selector: 'app-personal-identification',
  host: { 'data-version': 'v4pf' },
  standalone: true,
  imports: [
    CommonModule,
    SharedModuleV4,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatCardModule,
    MatButtonToggleModule,
    FormFieldComponent,
    FormFieldNumericComponent,
    AsFormControlPipe,
    AddressComponent,
    MatSlideToggleModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatButtonToggleGroup,
    MatError,
    MatSelectModule,
    MatOptionModule,
    FormFieldDateComponent,
    FormButtonGroupSimpleComponent,
    FormFieldSelectComponent,
  ],
  templateUrl: './personal-identification.component.html',
  styleUrl: './personal-identification.component.scss'
})
export class PersonalIdentificationComponent extends BaseStepComponent {
  @Input() parentFg!: FormGroup<PersonalIndividualForm>;
  @Input() fg!: FormGroup<Step2PersonalIdentificationForm>;

  @Input() parentStepper!: MatStepper;
  @Input() formSubmitted!: boolean;

  ApplicationFormControlNames = ApplicationFormControlNames;
  GenderEnum = GenderEnum;
  MaritalStatusEnum = MaritalStatusEnum;
  UserAction = UserAction;
  //NonResidentVisaTypeEnum = NonResidentVisaTypeEnum;
  IdentificationTypeEnum = IdentificationTypeEnum;
  SelectListType = SelectListType;
  //IdentificationTypeOtherEnum = IdentificationTypeOtherEnum;
  DateRangeType = DateRangeType;
  ResidencyStatusEnum = ResidencyStatusEnum;
  VisaTypeEnum = VisaTypeEnum;

  countriesNonResident: ListItem[] = [];
  individualApplicants: ListItem[] = [];
  individualHeaderDisplay: string = '';

  constructor(PersonalAppService: PersonalAppService, lookupService: LookupService) {
    super(PersonalAppService);

    lookupService.getCountries().subscribe((countries) => {
      //filter countries for non-resident
      this.countriesNonResident = countries.filter(country => country.valueCaption !== Country.Newzealand);
    });

  }



  override ngOnInit(): void {
    super.ngOnInit();

    this.subscriptions.push(this.personalAppService.individualType$.subscribe(value => {
      this.individualHeaderDisplay = this.personalAppService.buildIndividualHeaderInfo(value, this.parentFg);
    }));

    // Disable dependentsNo if it's not the primary individual
    var individualIndex = this.personalAppService.getIndividualIndex(this.parentFg);
    console.log('individualIndex', individualIndex);
    if (individualIndex != null && individualIndex > 0) {
      this.fg.controls.dependentsNo.disable();
    }

    this.fg.controls.driverLicenceNo.valueChanges.subscribe((value) => {
      var duplicateFound = false;
      this.personalAppService.personalApplicationFg?.indivFormArray?.controls.forEach((individualFg) => {
        if (individualFg != this.parentFg && individualFg.controls.step2.controls.driverLicenceNo.value == value) {
          this.fg.controls.driverLicenceNo.setErrors({ 'duplicate': true });
          duplicateFound = true;
        }
      });

      //clear the duplicate error if no duplicate found
      if (!duplicateFound) {
        this.clearError(this.fg.controls.driverLicenceNo, Constants.CustomErrors_Duplicate);
      }
    });

    this.subscriptions.push(this.fg.controls.identificationType.valueChanges.subscribe((value) => {

      this.disableControls([
        this.fg.controls.driverLicenceNo, this.fg.controls.driverLicenceVersion,
        this.fg.controls.passportNzExpiryDate, this.fg.controls.passportNzNumber,
        this.fg.controls.passportOtherExpiryDate, this.fg.controls.passportOtherNumber, this.fg.controls.passportOtherIssuerCountry,
        //this.fg.controls.otherIdType, this.fg.controls.otherIdDescription, this.fg.controls.otherIdNumber
      ]);

      switch (value) {
        case IdentificationTypeEnum.NzDriverLicense:
          this.enableControls([this.fg.controls.driverLicenceNo, this.fg.controls.driverLicenceVersion]);
          break;
        case IdentificationTypeEnum.NzPassport:
          this.enableControls([this.fg.controls.passportNzExpiryDate, this.fg.controls.passportNzNumber]);
          break;

        case IdentificationTypeEnum.OverseasPassport:
          this.enableControls([this.fg.controls.passportOtherExpiryDate, this.fg.controls.passportOtherNumber, this.fg.controls.passportOtherIssuerCountry]);
          break;
      }
    }));

  }
}








